import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { measurementsActions } from '../../../../../store/slices/measurementsSlice/measurementsSlice';

export const useCalculations = () => {
    const dispatch = useDispatch();
    const { isManualCalculations, calculations, manualCalculations } = useSelector(
        (state) => state.measurementsReducer
    );

    const onSwitcher = useCallback(() => {
        dispatch(measurementsActions.changeIsManualCalculations());
    }, [isManualCalculations]);

    const onInput = useCallback(
        (name, value) => {
            const changes = { [name]: value };
            dispatch(measurementsActions.changeManualCalculations(changes));
        },
        [calculations]
    );

    return { isManualCalculations, onSwitcher, onInput, calculations, manualCalculations };
};
